// TODO: merge with Url lib
export default function insertParams(url, parameters = {}, omitEmptyValues) {
  const properties = Object.getOwnPropertyNames(parameters);
  if (!properties.length) {
    return url;
  }

  const separator = (url.includes('?') ? '&' : '?');
  const query = properties
    .filter(property => !(omitEmptyValues && !parameters[property] && parameters[property] !== 0))
    .map(property => `${property}=${parameters[property]}`)
    .join('&');

  return `${url}${separator}${query}`;
}
